import React, {Component, Fragment} from "react";
import {withTranslate} from "react-redux-multilingual";
import SwitchStatues from "./SwitchStatuses";

class HistoryOptions extends Component {

    render() {
        const {pastReservation, translate, changePopUpStatus, rescheduleReservation} = this.props;
        return (
            <div id={"pastResDetails" + pastReservation.id} className="collapse hide">
                <SwitchStatues pastReservation={pastReservation} translate={translate} changePopUpStatus={changePopUpStatus} rescheduleReservation={rescheduleReservation} />
            </div>
        )
    }
}

export default withTranslate(HistoryOptions);

